
import React from "react";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { channelLabels, getChannelIcon } from "./AnalyticsUtils";
import { AutomatedMessage } from "../message-utils/types";
import { Mail, TrendingUp, MousePointer, ShoppingCart } from "lucide-react";

interface AnalyticsDetailsProps {
  message: AutomatedMessage;
}

const AnalyticsDetails = ({ message }: AnalyticsDetailsProps) => {
  return (
    <div className="space-y-4 pb-2">
      {Object.entries(message.metrics.byChannel).map(([channel, metrics]) => (
        <Card key={channel}>
          <CardContent className="pt-4">
            <div className="flex items-center gap-2 mb-4">
              {getChannelIcon(channel)}
              <CardTitle className="text-base">
                {channelLabels[channel as keyof typeof channelLabels]}
              </CardTitle>
            </div>
            <div className="grid grid-cols-4 gap-4">
              <div className="flex flex-col items-center justify-between h-full bg-gray-50 rounded-md py-3 px-2">
                <div className="flex flex-col items-center">
                  <Mail className="h-5 w-5 text-blue-500 mb-1" />
                  <p className="text-xs text-gray-500">Enviadas</p>
                </div>
                <p className="text-lg font-semibold text-gray-800 mt-auto">{metrics.sentCount}</p>
              </div>
              <div className="flex flex-col items-center justify-between h-full bg-gray-50 rounded-md py-3 px-2">
                <div className="flex flex-col items-center">
                  <TrendingUp className="h-5 w-5 text-green-500 mb-1" />
                  <p className="text-xs text-gray-500">Taxa de abertura</p>
                </div>
                <p className="text-lg font-semibold text-gray-800 mt-auto">{metrics.openRate}%</p>
              </div>
              <div className="flex flex-col items-center justify-between h-full bg-gray-50 rounded-md py-3 px-2">
                <div className="flex flex-col items-center">
                  <MousePointer className="h-5 w-5 text-purple-500 mb-1" />
                  <p className="text-xs text-gray-500">Taxa de clique</p>
                </div>
                <p className="text-lg font-semibold text-gray-800 mt-auto">{metrics.clickRate}%</p>
              </div>
              <div className="flex flex-col items-center justify-between h-full bg-gray-50 rounded-md py-3 px-2">
                <div className="flex flex-col items-center">
                  <ShoppingCart className="h-5 w-5 text-orange-500 mb-1" />
                  <p className="text-xs text-center text-gray-500">Taxa de<br />conversão</p>
                </div>
                <p className="text-lg font-semibold text-gray-800 mt-auto">{metrics.conversionRate}%</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AnalyticsDetails;
